export default "__VITE_ASSET__Nl3IlMPJ__"